import React from 'react';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { ClickAndGoSuccess } from './click-and-go/click-and-go-success';
import { MembershipInputSuccess } from './membership-input/membership-input-success';
import { SelectListSuccess } from './select-list/select-list-success';
import { LoanSuccess } from './loan/loan-success';

export function ViewSuccess(props) {
  const selectedProduct = props.selectedProduct;
  const enrollmentType = props.enrollmentType;
  const isClickAndGo = enrollmentType === 'CLICK-AND-GO';
  const isMembershipInput = enrollmentType === 'MEMBERSHIP-INPUT';
  const isMembershipInputRequired = enrollmentType === 'MEMBERSHIP-INPUT-REQUIRED';
  const isSelectList = enrollmentType === 'SELECT-LIST';
  const isLoan = enrollmentType === 'LOAN';
  const isMembershipInputInternational = enrollmentType === 'MEMBERSHIP-INPUT-INTERNATIONAL';
  const title = props?.content?.title;
  const description = props?.content?.description;
  const callToAction = props?.content?.callToAction;
  const cardname = props?.cardname;
  const benefitName = props?.benefitName;
  const benefitTitle = props?.benefitTitle;
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  return (
    <ExtendReactlytics analytics={{ event: { meta: { benefitname: `${parseEntities(benefitTitle)?.replace(/ /g, '-').toLowerCase()}` } } }}>
      <OnVisible analyticsInfo={{ element: `thank-you>>${cardname}>>enrollment` }}>
        {isClickAndGo && <ClickAndGoSuccess title={title} description={description} callToAction={callToAction} selectedProduct={selectedProduct} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} accountKey={props?.accountKey} />}
        {isMembershipInput && <MembershipInputSuccess title={title} description={description} callToAction={callToAction} selectedProduct={selectedProduct} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} accountKey={props?.accountKey} />}
        {isMembershipInputRequired && <MembershipInputSuccess title={title} description={description} callToAction={callToAction} selectedProduct={selectedProduct} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} accountKey={props?.accountKey} />}
        {isMembershipInputInternational && <MembershipInputSuccess title={title} description={description} callToAction={callToAction} selectedProduct={selectedProduct} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} accountKey={props?.accountKey} />}
        {isSelectList && <SelectListSuccess title={title} description={description} callToAction={callToAction} selectedProduct={selectedProduct} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} accountKey={props?.accountKey} />}
        {isLoan && <LoanSuccess title={title} description={description} callToAction={callToAction} selectedProduct={selectedProduct} benefitName={benefitName} cardname={cardname} benefitTitle={benefitTitle} accountKey={props?.accountKey} />}
      </OnVisible>
    </ExtendReactlytics>
  );
}
